// Core
import { useState, useEffect, useRef } from 'react';
import { MdInfoOutline } from "react-icons/md";
import { FaOilCan } from "react-icons/fa";
import { FaSitemap } from "react-icons/fa";
import { MdDoubleArrow } from 'react-icons/md';
import { FaHandshake } from "react-icons/fa6";
import { HiEmojiHappy } from "react-icons/hi";
import { MdToken } from 'react-icons/md';
import { FaWifi } from "react-icons/fa";
import { NavLink, Link } from 'react-router-dom';

// Chakra 
import { 
  Box,
  Button,
  Divider,
  Image,
  Flex, 
  Grid,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Text, 
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

const DonationsModal = ({ 
  isOpen, onOpen, onClose
}) => {

  //const link = process.env.REACT_APP_DONATION;

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}>
      <ModalOverlay />
      <ModalContent className="modal__simple modal__donation" maxW={{ sm: '100%', zIndex: '99999' }}>
        <ModalBody>
          <Text variant="title-lg" m="0 auto">Support the Creators!</Text>
          <Text mt="16px" variant="text">
            Enjoying the game? Show your love and appreciation by supporting the developers! 
            🌟 Your contribution helps us keep the game fun, fresh, and full of exciting updates. 🚀✨
            Every little bit counts — thank you with us! 🌟
          </Text>

          <Box p="25px 0 5px 0" w="100%">
            <a href="https://t.me/tribute/app?startapp=dmnj">
              <Button variant="button-md">Donate</Button>
            </a>

            <Box mt="24px">
              <Text variant="text-sm">
              © 2025 Spacecraft Game. All Rights Reserved.
              This game, including all assets, graphics, and mechanics, 
              is protected by copyright laws. 
              Any unauthorized reproduction, distribution, or modification is strictly prohibited.
              For inquiries or permissions, <a href="mailto:sudosuqwerty@gmail.com" style={{color: '#ea9e29'}}>contact us</a>
              </Text>
            </Box>


          </Box>
        </ModalBody>
      </ModalContent>
    </Modal> 
  );
};

export default DonationsModal;